"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StdoutTransport = exports.convertRecordToKVCollection = exports.convertMetaToKVCollection = exports.createELKMessageLog = exports.createELKErrorLog = void 0;
var ELKLogs_1 = require("./Log/ELKLogs");
Object.defineProperty(exports, "createELKErrorLog", { enumerable: true, get: function () { return ELKLogs_1.createELKErrorLog; } });
Object.defineProperty(exports, "createELKMessageLog", { enumerable: true, get: function () { return ELKLogs_1.createELKMessageLog; } });
__exportStar(require("./Log/IELKAppLog"), exports);
__exportStar(require("./Log/ILog"), exports);
var ExceptionData_1 = require("./Log/ExceptionData");
Object.defineProperty(exports, "convertMetaToKVCollection", { enumerable: true, get: function () { return ExceptionData_1.convertMetaToKVCollection; } });
Object.defineProperty(exports, "convertRecordToKVCollection", { enumerable: true, get: function () { return ExceptionData_1.convertRecordToKVCollection; } });
__exportStar(require("./Transport/ITransport"), exports);
var Stdout_1 = require("./Transport/Stdout");
Object.defineProperty(exports, "StdoutTransport", { enumerable: true, get: function () { return Stdout_1.StdoutTransport; } });
//# sourceMappingURL=index.js.map